import ActionPost from '@/components/action-post/ActionPost.vue'
import { FunctionalCalendar } from 'vue-functional-calendar'
import '@/components/calendar/Calendar.vue'
import '@/scripts/vue/dayjs'
import dayjs from 'dayjs'
import vSelect from 'vue-select'
import { BPagination, BPaginationNav } from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import fetchItems from '@/scripts/vue/api-axios'
import ListStateMixin from '@/mixins/ListStateMixin'

const categoryId = typeof window.category_id === "undefined" ? 2 : window.category_id
const perPageInitial = typeof window.perPageInitial === "undefined" ? 3 : window.perPageInitial

const monthNamesCs = ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'];
const monthNamesEn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const monthShortNamesCs = ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čvn', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'];
const monthShortNamesEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dayNamesCs = ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'];
const dayNamesEn = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];

const actionsListConfig = {
    mixins: [ListStateMixin('actionsList')],
    components: {
      FunctionalCalendar,
      ActionPost,
      vSelect,
      BPaginationNav,
      BPagination
    },
    data() {
      return {
        calendarData: {},
        calendarConfigs: {
          isDatePicker: true,
          isDateRange: false,
          dateFormat: 'yyyy-mm-dd',
          dayNames: document.documentElement.lang ==='cs' ? dayNamesCs : dayNamesEn,
          monthNames: document.documentElement.lang ==='cs' ? monthNamesCs : monthNamesEn,
          shortMonthNames: document.documentElement.lang ==='cs' ? monthShortNamesCs : monthShortNamesEn,
          changeYearFunction: true,
          changeMonthFunction: true,
          markedDateRange: [],
        },
        actions: [],
        categories: [],
        selectOptions: [],
        selectedCategory: null,
        currentPage: 1,
        perPage: perPageInitial,
        isLoaded: false,
        scrollerIsScrolling: false
      }
    },
    mounted() {
      this.$Progress.start();
      fetchItems(`/yiifcalendarevent?categoryId=${categoryId}`)
        .then((items) => {
          this.actions = items;
        })
        .then(() => {
          fetchItems(`yiifcategory/calendarevent`)
            .then((items) => {
              this.scrollTo('body', 0);

              this.categories = items;
              this.getSelectOptions();
              this.fixActionsDateRange();
              this.markActions();
              this.isLoaded = true;
              this.$Progress.finish();

              // category attribute from url
              const categoryParam = parseInt(window.utils.getQueryStringParameter('actionsCategory'));
              if ( categoryParam )
              {
                const currentCategory = this.selectOptions.filter(option => {
                  return option.id === categoryParam
                });

                this.selectedCategory = currentCategory[0];
              }

              // pagination attribute from url
              const pageParam = window.utils.getQueryStringParameter('actionsPage');
              if ( pageParam )
              {
                this.currentPage = pageParam;
              }

              // trigger current date on calendar, so default data get initiated
              $('.vfc-today').trigger('click');

              /*
              // in case we need to select custom date as default
              setTimeout(() => {
                console.log( this.$refs.Calendar.value.selectedDate );
                this.$refs.Calendar.value.selectedDate = '2021-4-30';
              }, 500);
              */

            })
        });
    },
    computed: {
      actionsSelected() {
        return this.actions
          .filter(item => {
            if (!item.dateFrom && !item.dateTo) return false
            return dayjs(this.calendarData.selectedDate).isBetween(item.dateFrom, item.dateTo, 'day', '[]')
          })
      },
      itemsForList() {
        return this.filteredItems.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage,
        );
      },
      rows() {
        return this.filteredItems.length
      },
      filteredItems() {
        return this.actions
          .filter(item => {
            if (!this.selectedCategory || !this.selectedCategory.id) return true;
            const articleCategories = new Set(Object.keys(item.category));
            const selectedCategories = this.selectedCategory.categories;
            for(let index = 0; index < selectedCategories.length; index++) {
              if (articleCategories.has(selectedCategories[index].toString())) return true
            }
          })
          .sort((a, b) => {
            if (a.dateFrom === null) {
              return 1;
            } else if (b.dateFrom === null) {
              return -1;
            } else
              return this.$date(a.dateFrom).isBefore(b.dateFrom, 'day') ? -1 : 1
          })
          .filter(item => {
            if (!item.dateFrom && !item.dateTo) return  true
            return this.$date(item.dateFrom).isAfter(dayjs(new Date()), 'day') || this.$date(item.dateTo).isAfter(dayjs(new Date()), 'day')
          })
      },
      isOnePage() {
        return this.rows <= this.perPage
      }
    },
    methods: {
      markActions() {
        this.actions.map(action => {
          this.calendarConfigs.markedDateRange.push({
            start: this.$date(action.dateFrom).format('YYYY-MM-DD'),
            end: this.$date(action.dateTo).format('YYYY-MM-DD')
          })
        })
      },
      fixActionsDateRange() {
        this.actions.map(item => {
          if (!item.dateFrom) item.dateFrom = item.dateTo;
          if (!item.dateTo) item.dateTo = item.dateFrom;
          if (dayjs(this.$date(item.dateTo)).isBefore(item.dateFrom, 'day')) item.dateTo = item.dateFrom;
        })
      },
      getSelectOptions() {
        this.categories.map(segment => {
          this.selectOptions.push({
            id: segment.id,
            title: null,
            group: segment.title
          });
          if(segment.children.length !== 0) {
            segment.children.map(category => {
              this.selectOptions.push({
                id: category.id,
                title: category.title,
                categories: category.children,
              });
            })
          }
        })

        /* show all option */
        if ( this.$refs.categorySelect?.placeholder )
        {
          // get Ids of all categories
          const allCategoriesIds = this.categories.map(category => category.id);

          // get placeholder from ref select
          const placeholder = this.$refs.categorySelect.placeholder;

          // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
          const clearOption = {
            categories: allCategoriesIds,
            id: 0,
            title: placeholder
          };

          this.selectOptions.unshift(clearOption);

          const defaultCategorySelected = parseInt(window.utils.getQueryStringParameter('actionsCategory')) > 0; 
          if ( ! defaultCategorySelected )
          {
            this.selectedCategory = clearOption;
          }
        }
        /* ___ show all option ___ */
      },
      getPostLink(postCategories) {
        let link = postCategories[categoryId];
        if (this.selectedCategory && this.selectedCategory.id) {
          const categories = new Set(this.selectedCategory.categories);
          for (let key in postCategories) {
            if (categories.has(parseInt(key))) {
              return postCategories[key]
            }
          }
        }
        return link
      },
      scrollTo(target, duration) {
        // if not scrolling already
        if ( !this.scrollerIsScrolling )
        {
          // scroll to target with desired duration
          VueScrollTo.scrollTo(target, {
            duration: duration,
            onStart: () => {
              // set scrolling variable
              this.scrollerIsScrolling = true;
            },
            onDone: () => {
              // unset scrolling variable
              this.scrollerIsScrolling = false;
            }
          });
        }
      }
    },
    watch: {
      perPage: function() {
        this.scrollTo('body', 500);
      },
      currentPage: function(newValue, oldValue) {
        this.scrollTo('body', 500);

        // change query string after changing pagination
        if ( newValue != oldValue )
        {
          window.utils.setQueryStringParameter('newsPage', this.currentPage);
        }
      },
      selectedCategory: function (newValue, oldValue) {
        if ( oldValue !== null && ( oldValue.id != newValue.id ) ) {
          this.currentPage = 1;
        }

        if ( newValue.id )
        {
          window.utils.setQueryStringParameter('actionsCategory', newValue.id);
        }
        else
        {
          window.utils.setQueryStringParameter('actionsCategory', 0);
        }
      }
    }
}

export default actionsListConfig;